export default __webpack_public_path__ + "static/media/ceo.7da9399d.png";